/**
 * Validation utility functions for form inputs
 */

// Email validation
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Phone validation (Nigerian format)
export const validatePhone = (phone) => {
  // Support formats: +234-XXX-XXX-XXXX, +234XXXXXXXXXX, 0XXXXXXXXXX
  const phoneRegex = /^(\+234|0)[7-9][0-1]\d{8}$/;
  const cleanPhone = phone.replace(/[\s-]/g, '');
  return phoneRegex.test(cleanPhone);
};

// Password validation (min 8 chars, 1 uppercase, 1 lowercase, 1 number)
export const validatePassword = (password) => {
  const minLength = password.length >= 8;
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  
  return {
    isValid: minLength && hasUppercase && hasLowercase && hasNumber,
    errors: {
      minLength,
      hasUppercase,
      hasLowercase,
      hasNumber
    }
  };
};

// Quantity validation
export const validateQuantity = (quantity, max = 99, min = 1) => {
  const num = parseInt(quantity, 10);
  if (isNaN(num)) return { isValid: false, error: 'Please enter a valid number' };
  if (num < min) return { isValid: false, error: `Minimum quantity is ${min}` };
  if (num > max) return { isValid: false, error: `Maximum quantity is ${max}` };
  return { isValid: true, value: num };
};

// Input sanitization to prevent XSS
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    "/": '&#x2F;',
  };
  const reg = /[&<>"'/]/ig;
  return input.replace(reg, (match) => (map[match]));
};

// Validate required field
export const validateRequired = (value, fieldName = 'This field') => {
  if (!value || (typeof value === 'string' && value.trim() === '')) {
    return { isValid: false, error: `${fieldName} is required` };
  }
  return { isValid: true };
};

// Name validation (letters, spaces, hyphens only)
export const validateName = (name) => {
  const nameRegex = /^[a-zA-Z\s-]{2,50}$/;
  if (!nameRegex.test(name)) {
    return { isValid: false, error: 'Name should contain only letters, spaces, or hyphens (2-50 characters)' };
  }
  return { isValid: true };
};

// Postal code validation
export const validatePostalCode = (code) => {
  const codeRegex = /^\d{6}$/;
  if (!codeRegex.test(code)) {
    return { isValid: false, error: 'Postal code should be 6 digits' };
  }
  return { isValid: true };
};

// Bulk quantity validation (allows very large numbers)
export const validateBulkQuantity = (quantity, max = 999999, min = 1) => {
  const num = parseInt(quantity, 10);
  if (isNaN(num)) return { isValid: false, error: 'Please enter a valid number' };
  if (num < min) return { isValid: false, error: `Minimum quantity is ${min}` };
  if (num > max) return { isValid: false, error: `Maximum quantity is ${max}` };
  return { isValid: true, value: num };
};
